enum Routes {
  ROLE_REQUIREMENTS = 'role-requirements',
  PROFILE = 'profile',
  DOCUMENTS = '',
  REVIEW = 'review',
  PROFILE_PRIVACY = '/profile-privacy',
}

export default Routes;
